class BioCartReservation extends HTMLElement {
  connectedCallback() {
    this.duration = Math.max(1, Number(this.dataset.minutes || 10)) * 60 * 1000;
    this.output = this.querySelector('[data-bio-cart-countdown]');
    this.key = 'nuvezza-cart-reservation-expiry';

    const storedExpiry = Number(sessionStorage.getItem(this.key) || 0);
    this.expiry = storedExpiry > Date.now() ? storedExpiry : Date.now() + this.duration;
    sessionStorage.setItem(this.key, String(this.expiry));
    this.update();
    this.interval = window.setInterval(() => this.update(), 1000);
  }

  disconnectedCallback() {
    window.clearInterval(this.interval);
  }

  update() {
    let remaining = this.expiry - Date.now();
    if (remaining <= 0) {
      this.expiry = Date.now() + this.duration;
      sessionStorage.setItem(this.key, String(this.expiry));
      remaining = this.duration;
    }

    const totalSeconds = Math.max(0, Math.floor(remaining / 1000));
    const minutes = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const seconds = String(totalSeconds % 60).padStart(2, '0');
    if (this.output) this.output.textContent = `${minutes}:${seconds}`;
  }
}

if (!customElements.get('bio-cart-reservation')) {
  customElements.define('bio-cart-reservation', BioCartReservation);
}
